import { Fingerprint } from 'lucide-react'
import { useState } from 'react'

import { FormAlert } from '@/components/feedback/FormAlert'
import { Button } from '@/components/ui'
import { suportaBiometria } from '@/features/biometria/services/webauthn'

import { useDesbloqueio, useSairDoDesbloqueio } from '../hooks/useDesbloqueio'
import { AuthLayout } from './AuthLayout'

/**
 * Sessão travada pela API até a biometria. O leitor só abre no clique: o Safari recusa a
 * WebAuthn sem gesto do usuário. Mantém a URL — após desbloquear, a mesma página abre.
 */
export function DesbloqueioScreen() {
  const [suportado] = useState(suportaBiometria)
  const desbloqueio = useDesbloqueio()
  const sair = useSairDoDesbloqueio()
  const [erro, setErro] = useState<string | null>(null)
  const [recusada, setRecusada] = useState(false)

  const desbloquear = () => {
    setErro(null)
    desbloqueio.mutate(undefined, {
      onSuccess: (resultado) => {
        if (resultado.tipo !== 'erro') return
        setErro(resultado.mensagem)
        setRecusada(resultado.biometriaRecusada)
      },
    })
  }

  const ocupado = desbloqueio.isPending || sair.isPending
  // Sem suporte ou biometria recusada: o caminho natural passa a ser a senha.
  const senhaEmDestaque = !suportado || recusada

  return (
    <AuthLayout
      title="Sessão bloqueada"
      subtitle={
        suportado
          ? 'Confirme sua identidade com a biometria para continuar.'
          : 'Este navegador não suporta biometria. Entre com sua senha para continuar.'
      }
      footer={<span>© {new Date().getFullYear()} Irmãos Pacheco</span>}
    >
      <div className="flex flex-col gap-3">
        <FormAlert message={erro} />
        {suportado && (
          <Button
            fullWidth
            size="lg"
            variant={senhaEmDestaque ? 'outline' : 'primary'}
            onClick={desbloquear}
            loading={desbloqueio.isPending}
            disabled={sair.isPending}
          >
            {!desbloqueio.isPending && <Fingerprint className="size-5" />}
            Desbloquear com biometria
          </Button>
        )}
        <Button
          fullWidth
          size="lg"
          variant={senhaEmDestaque ? 'primary' : 'ghost'}
          onClick={() => sair.mutate()}
          loading={sair.isPending}
          disabled={ocupado && !sair.isPending}
        >
          Entrar com senha
        </Button>
      </div>
    </AuthLayout>
  )
}
